<div class="modal-header border-0 py-0">
    <h4 class="modal-title pull-left border-0 p-0"><b>{{isEdit? 'Update':
            'Add New'}} {{firewallServer?'Firewall':''}} Server</b></h4>
</div>
<form action="" [formGroup]="serverForm">
    <div class="modal-body pt-0 pb-0">
        <div class="row mb-3">
            <div class="col-sm-3 mb-3">
                <label for="fullName" class="col-form-label">Full Name <span class="text-danger">*</span></label>
                <div class=" mt-1">
                    <input type="text" class="form-control" id="fullName" placeholder="Enter Name"
                        formControlName="name">
                    <div *ngIf="serverForm.get('name')?.invalid" class="alert mb-0 p-0">
                        <div class="error-message"
                            *ngIf="serverForm.get('name')?.errors?.['required'] && (serverForm.get('name')?.dirty || serverForm.get('name')?.touched)">
                            <p class="text-danger mt-1 p-0"><small>Name is mandatory.</small>
                            </p>
                        </div>
                        <div class="error-message" *ngIf="serverForm.get('name')?.errors?.['pattern']">
                            <p class="text-danger mt-1 p-0"><small>Please enter valid Name.</small></p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-3 mb-3">
                <label for="hostName" class="col-form-label">HostName<span class="text-danger">*</span></label>
                <div class=" mt-1">
                    <input type="text" class="form-control" id="hostName" placeholder="Enter HostName"
                        formControlName="hostName">
                    <div *ngIf="serverForm.get('hostName')?.invalid" class="alert mb-0 p-0">
                        <div class="error-message"
                            *ngIf="serverForm.get('hostName')?.errors?.['required'] && (serverForm.get('hostName')?.dirty || serverForm.get('hostName')?.touched)">
                            <p class="text-danger mt-1 p-0"><small>HostName is mandatory.</small>
                            </p>
                        </div>
                        <div class="error-message" *ngIf="serverForm.get('hostName')?.errors?.['pattern']">
                            <p class="text-danger mt-1 p-0"><small>Please enter valid HostName.</small></p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-3 mb-3">
                <label for="fullName" class="col-form-label">IP Address <span class="text-danger">*</span></label>
                <div class=" mt-1">
                    <input type="text" class="form-control" id="fullName" placeholder="Enter IP Address"
                        formControlName="ip">
                    <div *ngIf="serverForm.get('ip')?.invalid" class="alert mb-0 p-0">
                        <div class="error-message"
                            *ngIf="serverForm.get('ip')?.errors?.['required'] && (serverForm.get('ip')?.dirty || serverForm.get('ip')?.touched)">
                            <p class="text-danger mt-1 p-0"><small>IP Address is mandatory.</small>
                            </p>
                        </div>
                        <div class="error-message" *ngIf="serverForm.get('ip')?.errors?.['pattern']">
                            <p class="text-danger mt-1 p-0"><small>Please enter valid IP Address.</small></p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-3 mb-3">
                <label for="fullName" class="col-form-label">Public IP Address <span
                        class="text-danger">*</span></label>
                <div class=" mt-1">
                    <input type="text" class="form-control" id="fullName" placeholder="Enter Public IP Address"
                        formControlName="publicIp">
                    <div *ngIf="serverForm.get('publicIp')?.invalid" class="alert mb-0 p-0">
                        <div class="error-message"
                            *ngIf="serverForm.get('publicIp')?.errors?.['required'] && (serverForm.get('publicIp')?.dirty || serverForm.get('publicIp')?.touched)">
                            <p class="text-danger mt-1 p-0"><small>Public IP is mandatory.</small>
                            </p>
                        </div>
                        <div class="error-message" *ngIf="serverForm.get('publicIp')?.errors?.['pattern']">
                            <p class="text-danger mt-1 p-0"><small>Please enter valid IP Address.</small></p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-3 mb-3" *ngIf="firewallServer !=='firewall'">
                <label for="fullName" class="col-form-label">Domain Name <span class="text-danger">*</span></label>
                <div class="mt-1">
                    <input type="text" class="form-control" id="fullName" placeholder="Enter Domain Name"
                        formControlName="domainName">
                    <div *ngIf="serverForm.get('domainName')?.invalid" class="alert mb-0 p-0">
                        <div class="error-message"
                            *ngIf="serverForm.get('domainName')?.errors?.['required'] && (serverForm.get('domainName')?.dirty || serverForm.get('domainName')?.touched)">
                            <p class="text-danger mt-1 p-0"><small>Domain Name is mandatory.</small>
                            </p>
                        </div>
                        <div class="error-message" *ngIf="serverForm.get('domainName')?.errors?.['pattern']">
                            <p class="text-danger mt-1 p-0"><small>Please enter valid Domain Name.</small></p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-3 mb-3">
                <label for="fullName" class=" col-form-label">RAM <span class="text-danger">*</span></label>
                <div class="mt-1">
                    <input type="number" class="form-control" id="fullName" placeholder="Enter ram"
                        formControlName="ram">
                    <div *ngIf="serverForm.get('ram')?.invalid" class="alert mb-0 p-0">
                        <div class="error-message"
                            *ngIf="serverForm.get('ram')?.errors?.['required'] && (serverForm.get('ram')?.dirty || serverForm.get('ram')?.touched)">
                            <p class="text-danger mt-1 p-0"><small>RAM is mandatory.</small>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-3 mb-3">
                <label for="fullName" class=" col-form-label">CPU <span class="text-danger">*</span></label>
                <div class="mt-1">
                    <input type="number" class="form-control" id="fullName" placeholder="Enter cpu"
                        formControlName="cpu">
                    <div *ngIf="serverForm.get('cpu')?.invalid" class="alert mb-0 p-0">
                        <div class="error-message"
                            *ngIf="serverForm.get('cpu')?.errors?.['required'] && (serverForm.get('cpu')?.dirty || serverForm.get('cpu')?.touched)">
                            <p class="text-danger mt-1 p-0"><small>CPU is mandatory.</small>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-3 mb-3">
                <label for="fullName" class=" col-form-label">Storage <span class="text-danger">*</span></label>
                <div class="mt-1">
                    <input type="number" class="form-control" id="fullName" placeholder="Enter storage"
                        formControlName="storage">
                    <div *ngIf="serverForm.get('storage')?.invalid" class="alert mb-0 p-0">
                        <div class="error-message"
                            *ngIf="serverForm.get('storage')?.errors?.['required'] && (serverForm.get('storage')?.dirty || serverForm.get('storage')?.touched)">
                            <p class="text-danger mt-1 p-0"><small>Storage is mandatory.</small>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-3 mb-3">
                <label for="fullName" class="col-form-label">Description</label>
                <div class="mt-1">
                    <textarea rows="1" class="form-control pt-2" id="fullName" placeholder="Description"
                        style="overflow:hidden" formControlName="description"></textarea>
                </div>
            </div>
            <div class="col-sm-3 mb-3" *ngIf="firewallServer !=='firewall'">
                <label for="fullName" class=" col-form-label">Select exe for Api call <span
                        class="text-danger">*</span></label>
                <div class=" mt-1">
                    <select class="form-select text-muted" formControlName="selectExe">
                        <option value="oldExe">Old exe</option>
                        <option value="newExe">New exe</option>
                    </select>
                </div>
            </div>
            <div class="col-sm-3 mb-3" *ngIf="firewallServer !=='firewall'">
                <label for="fullName" class=" col-form-label">Server Type <span class="text-danger">*</span></label>
                <div class=" mt-1">
                    <select class="form-select text-muted" formControlName="serverType">
                        <option value="live">Live Server</option>
                        <option value="trial">Trial Server</option>
                        <option value="marg">Marg Server</option>
                        <option value="partner">Partner Server</option>
                        <option value="custom">Custom Server</option>
                    </select>
                </div>
            </div>
            <div class="col-sm-3 mb-3" *ngIf="firewallServer !=='firewall'">
                <label for="fullName" class=" col-form-label">Auto Provision <span class="text-danger">*</span></label>
                <div class=" mt-1">
                    <select class="form-select text-muted" formControlName="autoProvision">
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                    </select>
                </div>
            </div>
            <div class="col-sm-3 mb-3" *ngIf="firewallServer !=='firewall'">
                <label for="fullName" class=" col-form-label">Select Firewall Server <span
                        class="text-danger">*</span></label>
                <div class=" mt-1">
                    <select class="form-select text-muted" formControlName="firewallServerId">
                        <option value="" disabled>Select Firewall Server</option>
                        <option *ngFor="let server of firewallList" [value]="server?._id">{{server.name}}</option>

                    </select>
                    <div *ngIf="serverForm.get('firewallServerId')?.invalid" class="alert mb-0 p-0">
                        <div class="error-message"
                            *ngIf="serverForm.get('firewallServerId')?.errors?.['required'] && (serverForm.get('firewallServerId')?.dirty || serverForm.get('firewallServerId')?.touched)">
                            <p class="text-danger mt-1 p-0"><small>It is mandatory.</small>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-3 mb-3">
                <label for="userName" class="col-form-label">Username <span class="text-danger">*</span></label>
                <div class=" mt-1">
                    <input type="text" class="form-control" id="userName" placeholder="Enter username"
                        formControlName="userName">
                    <div *ngIf="serverForm.get('userName')?.invalid" class="alert mb-0 p-0">
                        <div class="error-message"
                            *ngIf="serverForm.get('userName')?.errors?.['required'] && (serverForm.get('userName')?.dirty || serverForm.get('userName')?.touched)">
                            <p class="text-danger mt-1 p-0"><small>It is mandatory.</small>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-3 mb-3">
                <label for="password" class="col-form-label">Password <span class="text-danger">*</span></label>
                <div class=" mt-1">
                    <input type="password" class="form-control" id="password" placeholder="Enter password"
                        formControlName="password">
                    <div *ngIf="serverForm.get('password')?.invalid" class="alert mb-0 p-0">
                        <div class="error-message"
                            *ngIf="serverForm.get('password')?.errors?.['required'] && (serverForm.get('password')?.dirty || serverForm.get('password')?.touched)">
                            <p class="text-danger mt-1 p-0"><small>It is mandatory.</small>
                            </p>
                        </div>
                        <div class="error-message" *ngIf="serverForm.get('password')?.errors?.['minlength']">
                            <p class="text-danger mt-1 p-0"><small>Password must be at
                                    least 6 characters.</small></p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-3 mb-3" *ngIf="firewallServer =='firewall'">
                <label for="fullName" class=" col-form-label">Port <span class="text-danger">*</span></label>
                <div class="mt-1">
                    <input type="number" class="form-control" id="fullName" placeholder="Enter port"
                        formControlName="port">
                    <div *ngIf="serverForm.get('port')?.invalid" class="alert mb-0 p-0">
                        <div class="error-message"
                            *ngIf="serverForm.get('port')?.errors?.['required'] && (serverForm.get('port')?.dirty || serverForm.get('port')?.touched)">
                            <p class="text-danger mt-1 p-0"><small>Port is mandatory.</small>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-3 mb-3">
                <label for="rdpPort" class="col-form-label">RDP Port <span class="text-danger">*</span></label>
                <div class="mt-1">
                    <input type="number" class="form-control" id="rdpPort" placeholder="Enter RDP port"
                        formControlName="rdpPort" />

                    <div *ngIf="serverForm.get('rdpPort')?.invalid && (serverForm.get('rdpPort')?.dirty || serverForm.get('rdpPort')?.touched)"
                        class="alert mb-0 p-0">
                        <p *ngIf="serverForm.get('rdpPort')?.errors?.['required']" class="text-danger mt-1 p-0">
                            <small>RDP port is mandatory.</small>
                        </p>
                        <p *ngIf="serverForm.get('rdpPort')?.errors?.['min'] || serverForm.get('rdpPort')?.errors?.['max']"
                            class="text-danger mt-1 p-0">
                            <small>RDP Port must be between 1 and 65535.</small>
                        </p>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <div class="modal-footer border-0 p-0 m-0">
        <div class="row">
            <div class="col-sm-12 mt-2 text-end">
                <button type="submit" class="comman-btn1 btn-primary me-2" (click)="submit()">{{isEdit? 'Update':
                    'Submit'}}</button>
                <button type="button" class="comman-btn1 btn-secondary text-light me-2"
                    (click)="closedModal()">Cancel</button>
            </div>
        </div>
    </div>
</form>